import { ReactTableRow } from '../gridReactTable'

export interface GridRowParams {
  /**
   * The grid row id.
   */
  rowId: ReactTableRow['id']
}

/**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */
export interface GridRowHeightParams {
  /**
   * The grid current density factor.
   */
  densityFactor: number
}

/**
 * The getRowHeight return value.
 */
export type GridRowHeightReturnValue = number | null | undefined | 'auto'

enum GridRowEditStartReasons {
  enterKeyDown = 'enterKeyDown',
  cellDoubleClick = 'cellDoubleClick',
  printableKeyDown = 'printableKeyDown',
  deleteKeyDown = 'deleteKeyDown',
}

/**
 * Params passed to the `rowEditStart` event.
 */
export interface GridRowEditStartParams extends GridRowParams {
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: ReactTableRow
  /**
   * Which field triggered this event.
   */
  field?: string
  /**
   * The reason for this event to be triggered.
   */
  reason?: GridRowEditStartReasons
  /**
   * If the reason is related to a keyboard event, it contains which key was pressed.
   */
  key?: string
}

enum GridRowEditStopReasons {
  rowFocusOut = 'rowFocusOut',
  escapeKeyDown = 'escapeKeyDown',
  enterKeyDown = 'enterKeyDown',
  tabKeyDown = 'tabKeyDown',
  shiftTabKeyDown = 'shiftTabKeyDown',
}

export interface GridRowEditStopParams extends GridRowParams {
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: ReactTableRow
  /**
   * Which field triggered this event.
   */
  field?: string
  /**
   * The reason for this event to be triggered.
   */
  reason?: GridRowEditStopReasons
}

// https://github.com/mui/mui-x/pull/3738#discussion_r798504277
export { GridRowEditStartReasons, GridRowEditStopReasons }
